// Светлая или тёмная тема сайта. Выбор живёт в cookie, а не в localStorage:
// сервер читает её и сразу отдаёт <html class="dark">, поэтому при загрузке
// страница не вспыхивает белым перед переключением. По умолчанию — светлая
// (тема системы не подхватывается: на сервере её не узнать без той же вспышки)
export type ThemeName = "light" | "dark";

const YEAR = 60 * 60 * 24 * 365;

export function useTheme() {
  const cookie = useCookie<ThemeName>("theme", {
    default: () => "light",
    maxAge: YEAR,
    sameSite: "lax",
    path: "/",
  });

  const isDark = computed(() => cookie.value === "dark");

  // Класс на <html> ставится сразу, не дожидаясь перерисовки через useHead:
  // иначе плавная смена темы (View Transitions) снимала бы «старый» кадр
  // уже с наполовину перекрашенной страницы
  const setTheme = (theme: ThemeName) => {
    cookie.value = theme;
    if (import.meta.client) document.documentElement.classList.toggle("dark", theme === "dark");
  };

  return { isDark, theme: cookie, setTheme };
}
